import { render, staticRenderFns } from "./MasterclassDetails.vue?vue&type=template&id=931e0388&scoped=true&"
import script from "./MasterclassDetails.vue?vue&type=script&lang=js&"
export * from "./MasterclassDetails.vue?vue&type=script&lang=js&"
import style0 from "./MasterclassDetails.vue?vue&type=style&index=0&id=931e0388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931e0388",
  null
  
)

export default component.exports